export default "__VITE_ASSET__6hGBM0xR__"